import BaseApiService from '../base/BaseApiService';
import type { SupplierTierAdmin } from '@app-types/supplier-tier-admin';

export interface UpdateSupplierTierRequest {
  name: string;
  description?: string | null;
}

class SupplierTierAdminService extends BaseApiService {
  async getAll(): Promise<SupplierTierAdmin[]> {
    return this.get<SupplierTierAdmin[]>('/admin/supplier-tiers');
  }

  async update(id: number, data: UpdateSupplierTierRequest): Promise<SupplierTierAdmin> {
    return this.put<SupplierTierAdmin>(`/admin/supplier-tiers/${id}/name`, data);
  }
}

export const supplierTierAdminService = new SupplierTierAdminService();
